import React from 'react';
import { useTranslation } from 'react-i18next';

interface SuccessMessageProps {
  message: string;
}

const SuccessMessage: React.FC<SuccessMessageProps> = ({ message }) => {
  const { t } = useTranslation();
  return (
    <div className="bg-gradient-to-r from-green-50 to-green-100 text-green-800 border-2 border-green-500 
                   rounded-lg p-4 mb-6 font-medium animate-slideIn">
      <div className="flex items-center">
        <span className="text-xl mr-2">✅</span>
        {t(message)}
      </div>
    </div>
  );
};

export default SuccessMessage;